import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Activity, Brain } from 'lucide-react';
import { Line } from 'react-chartjs-2';

interface ClientMetricsProps {
  metrics: {
    recovery: number;
    strain: number;
    sleep: number;
  };
}

export function ClientMetrics({ metrics }: ClientMetricsProps) {
  const data = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Recovery',
        data: [75, 82, 78, 85, metrics.recovery, 88, 84],
        borderColor: 'hsl(var(--success))',
        tension: 0.4
      },
      {
        label: 'Strain',
        data: [12.4, 14.2, 11.8, 13.5, metrics.strain, 10.8, 12.6],
        borderColor: 'hsl(var(--primary))',
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return (
    <div className="theme-card p-6">
      <h2 className="text-lg font-semibold mb-6">Performance Metrics</h2>

      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-muted/30 p-4 rounded-lg">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
            <Heart className="w-4 h-4 text-primary" />
            <span>Recovery</span>
          </div>
          <div className="text-2xl font-bold">{metrics.recovery}%</div>
        </div>
        <div className="bg-muted/30 p-4 rounded-lg">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
            <Activity className="w-4 h-4 text-primary" />
            <span>Strain</span>
          </div>
          <div className="text-2xl font-bold">{metrics.strain}</div>
        </div>
        <div className="bg-muted/30 p-4 rounded-lg">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
            <Brain className="w-4 h-4 text-primary" />
            <span>Sleep</span>
          </div>
          <div className="text-2xl font-bold">{metrics.sleep}%</div>
        </div>
      </div>

      <div className="h-64">
        <Line data={data} options={options} />
      </div>
    </div>
  );
}